<template>
  <div class="fireMsgWarp" v-if="show">
    <div class="fireInner">
      <p class="title">手机验证 <span class="closeBtn" @click="close"></span></p>
      <div class="sendInner">
        <p><span class="sendName">手机号：</span><span class="phoneNum">{{gUserInfo.userDetailResult.user_phone}}</span><span class="getCode"
                                                                                             @click="getPhoneCode">{{codeTxt}}</span>
        </p>
        <p><span class="sendName">验证码：</span><input type="text" placeholder="输入验证码" v-model="code"></p>
      </div>
      <div class="sendBottom">
        <div class="saveWarp">
          <div class="saveBtn blue" @click="sub">确定</div>
          <div class="saveBtn grey" @click="close">取消</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapActions, mapGetters} from 'vuex'
  export default {
    props: ['htid'],
    data() {
      return {
        codeTxt: '获取验证码',
        canClick: true,
        phoneNumber: '',
        show: false,
        code: ''
      }
    },
    computed: {
      ...mapGetters(['gUserInfo'])
    },
    created(){
    },
    methods: {
      close() {
        this.show = false
      },
      sub() {
        let vm = this;
        vm.ajpost('/api/contract/addSmsCode',
          {code: vm.code, contractId: vm.htid}
          , function (data) {
          console.log(data)
            if (data.code == 0) {
              vm.callBack()
              vm.close()
            }else {
              vm.$message({
                message:data.msg,
                type: 'warning'
              });
            }
          });
      },
      callBack(){},
      getPhoneCode() {
        let vm = this;
        if (this.canClick) {
          this.canClick = false;
          let num = 60;
          vm.ajpost('/api/contract/getSmsCode', {id: vm.htid}, function (data) {
            if (data.code == 0) {
              vm.se = setInterval(function () {
                if (num != 0) {
                  vm.codeTxt = `${num}s`;
                  num = num - 1;
                } else {
                  clearInterval(vm.se);
                  vm.canClick = true;
                  vm.codeTxt = '获取验证码'
                }
              }, 1000)
            }else {
              vm.$message({
                message: data.msg,
                type: 'warning'
              });
            }
          });
        }
      }
    }
  }
</script>
<style lang="less" scoped="scoped">
  .fireMsgWarp {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    z-index: 12;
    display: flex;
    justify-content: center;
    align-items: center;
    .fireInner {
      width: 400px;
      background: #ffffff;
      .title {
        padding-left: 20px;
        line-height: 50px;
        font-size: 14px;
        background: rgb(236, 240, 243);
        .closeBtn {
          width: 15px;
          display: inline-block;
          float: right;
          height: 15px;
          background: url("../../assets/images/icon_close1.png");
          /*background:red;*/
          background-size: 100% 100%;
          margin: 13px 13px 0 0;
          cursor: pointer;
        }
      }
      .sendInner {
        padding: 15px 29px 0px 20px;
        p {
          display: flex;
          margin-bottom: 15px;
          align-items: center;
          .sendName {
            flex: 75px 0 0;
            font-size: 12px;
            color: rgb(126, 126, 126);
          }
          .phoneNum {
            flex: 1;
            color: rgb(126, 126, 126);
            font-size: 12px;
          }
          .getCode {
            flex: 90px 0 0;
            line-height: 28px;
            border: 1px solid rgb(219, 219, 219);
            border-radius: 2px;
            font-size: 12px;
            text-align: center;
            color: rgba(0, 0, 0, 0.6);
            cursor: pointer;
          }
          input {
            background: rgb(249, 249, 249);
            border: 1px solid rgb(220, 220, 220);
            flex: 1;
            height: 30px;
            font-size: 12px;
          }
        }
      }
      .sendBottom {
        padding: 15px 0;
        .saveWarp {
          width: 220px;
          margin: 0 auto;
          .saveBtn {
            display: inline-block;
            font-size: 10px;
            width: 100px;
            line-height: 25px;
            border: 1px solid rgba(186, 186, 186, 0);
            border-radius: 2px;
            cursor: pointer;
            text-align: center;
            &.blue {
              background: rgb(6, 59, 183);
              color: #ffffff;
              margin-right: 20px;
            }
            &.grey {
              background: #ffffff;
              border-color: grey;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fire/fireMsg.vue